export default "<p>sale-update-profile works!</p>\n"